import { render, staticRenderFns } from "./EdimensajeerrorGrid.vue?vue&type=template&id=b28656e2"
import script from "./EdimensajeerrorGrid.vue?vue&type=script&lang=js"
export * from "./EdimensajeerrorGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports